export default "__VITE_ASSET__2ebe0c2d__"